import PropTypes from 'prop-types';

import parseHtmlBody from '../utils/parseHtmlBody';

import './ListingContent.scss';

const ListingContent = ({ className = '', content }) => (
  <div
    className={`listing-content ${className}`}
    dangerouslySetInnerHTML={{ __html: parseHtmlBody(content) }}
  />
);

ListingContent.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string.isRequired
};

export default ListingContent;
